import React, { useEffect, useState } from 'react';
import Image from 'next/image';
import { useTheme } from 'next-themes';
import { isWhiteLabelEnabled, getWhiteLabelLogoUrl } from 'utils/whiteLabelConfig';

const DEFAULT_LOGO = '/logo/thera-logo-new.svg';
const DEFAULT_LOGO_DARK = '/logo/thera-logo-white-new.svg';

interface LogoProps {
  className?: string;
  alt?: string;
  useImage?: boolean;
  priority?: boolean;
  sizes?: string;
}

const Logo: React.FC<LogoProps> = ({
  className = 'h-8 w-auto',
  alt = 'Company Logo',
  useImage = false,
  priority = false,
  sizes,
}) => {
  const { resolvedTheme } = useTheme();
  // next-themes only knows the real theme after mount; render the light
  // asset until then so server and client markup match.
  const [themeReady, setThemeReady] = useState(false);
  useEffect(() => setThemeReady(true), []);

  const baseLogoUrl = isWhiteLabelEnabled() ? getWhiteLabelLogoUrl() : DEFAULT_LOGO;
  // Only the default Thera logo gets a dark-mode swap; white-label tenant
  // logos are left untouched.
  const logoUrl =
    themeReady && resolvedTheme === 'dark' && baseLogoUrl === DEFAULT_LOGO ? DEFAULT_LOGO_DARK : baseLogoUrl;

  if (useImage) {
    return <Image src={logoUrl} alt={alt} fill className={className} priority={priority} sizes={sizes} />;
  }

  return <img className={className} src={logoUrl} alt={alt} />;
};

export default Logo;
